module.exports = require('../impls/async-interleave-ready/async-interleave-ready.js').asyncInterleaveReady;